<template>
<div class="form">
<a-card title="告警记录编辑">
        <v-gobackbutton slot="extra" >返回</v-gobackbutton>
        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout"  :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item ref="syscode" label="系统编码" prop="syscode">
                <a-input disabled
                    v-model="record.syscode"
                     @blur="
                        () => {
                            $refs.syscode.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>

            <a-form-model-item ref="appcode" label="appcode" prop="appcode">
                <a-input disabled
                    v-model="record.appcode"
                     @blur="
                        () => {
                            $refs.appcode.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>
            <a-form-model-item ref="title" label="预警项" prop="title">
                <a-input disabled
                    v-model="record.title"
                     @blur="
                        () => {
                            $refs.title.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>

            <a-form-model-item ref="exceptioncode" label="错误码" prop="exceptioncode">
                <a-input disabled
                    v-model="record.exceptioncode"
                     @blur="
                        () => {
                            $refs.exceptioncode.onFieldBlur();
                        }
                        "
                />            
            </a-form-model-item>
            <a-form-model-item ref="serviceurl" label="中仑服务地址" prop="serviceurl">
                <a-input disabled
                    v-model="record.serviceurl"
                     @blur="
                        () => {
                            $refs.serviceurl.onFieldBlur();
                        }
                        "
                />            
            </a-form-model-item>
                   <a-form-model-item ref="blocktime" label="当前屏蔽到期时间" prop="blocktime">
                   <a-input disabled v-model="record.blocktime" />            
            </a-form-model-item>

            <!-- <a-form-model-item  display:none  ref="blockid" label="屏蔽id" prop="blockid">
                <a-input disabled v-model="record.blockid" />            
            </a-form-model-item> -->

            <a-form-model-item label="处理状态" prop="dealstatus" >
            <a-select v-model="record.dealstatus" placeholder="请选择" style="width:200px" >
                <a-select-option value="0">
                 未处理
                </a-select-option>
                <a-select-option value="1">
                 处理中
                </a-select-option>
                <a-select-option value="2">
                 已处理
                </a-select-option>
            </a-select>
            </a-form-model-item>
            <a-form-model-item label="屏蔽服务通知" prop="blocktype">
                <a-select v-model="record.blocktype" placeholder="请选择屏蔽时间" style="width:200px">
                    <a-select-option value="0">
                     0分钟
                    </a-select-option>
                    <a-select-option value="5">
                    5分钟
                    </a-select-option>
                    <a-select-option value="15">
                    15分钟
                    </a-select-option>
                    <a-select-option value="30">
                    30分钟
                    </a-select-option>
                    <a-select-option value="1d">
                    1天
                    </a-select-option>
                    <a-select-option value="7d">
                    1周
                    </a-select-option>
                     <a-select-option value="14d">
                    2周
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            

            
            <a-form-model-item label="备注" prop="dealdesc" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="record.dealdesc" type="textarea" />
            </a-form-model-item>

            <a-form-model-item v-show="is_vue_task"  :wrapper-col="{ span: 14, offset: 10 }" >
              <a-popconfirm title="确定无业务影响屏蔽该服务告警？" @confirm="() => handleOk()">
                  <a-button type="primary">
                    保存
                 </a-button>
             </a-popconfirm>

                <a-button style="margin-left: 10px;" @click="handleCancel">
                    取消
                </a-button>
            </a-form-model-item>
        </a-form-model>

 </a-card>
</div>
  
</template>
<script>
import { mapState } from "vuex";

export default {
    data() {
        return {
            is_vue_task : true,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {
                
            },
            confirmLoading: false,
            formItemLayout:'horizontal'
        };
    },
    computed: {
        ...mapState("alarmmanager", {
            record: function(state) {
                return state.record;
            }
        })
    },

    methods: {
        handleOk() {
            this.confirmLoading = true;
            //编辑
            this.record.id = this.record.id;
            this.$store
                .dispatch({
                    type: "alarmmanager/edit",
                    params: this.record
                })
                .then((response) => {
                    if(response.data.success == '1'){
                        console.log(response)
                        this.handleCancel();
                        this.confirmLoading = false;
                    }
                });
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },

    mounted(){
        const { query } = this.$route;
        this.$store.dispatch({
            type: "alarmmanager/details",
            params: query,
            showMsg: false
        })
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
